/**
 * Создаёт Redux-thunk для подписки на socket.io событие с автоматической обработкой формата { result, data }.
 *
 * @param {string} eventName - Название socket-события, например 'brigade_get_reply'.
 * @param {function|string} actionOrType - Action creator (функция) или строка с type. Если строка, создаётся экшен { type, payload: data }.
 * @param {function} [onError] - Action creator для обработки ошибок. Вызывается, если result !== 'ok'.
 * @param {boolean} [raw=false] - Если true, отключает обработку result/data и передаёт payload напрямую.
 *
 * @returns {Function} thunk-функция, которую можно передать в useEffect или dispatch — возвращает функцию отписки от события.
 */
export const createSocketListener = (eventName, actionOrType, onError, raw = false) => {
  return () =>
    (dispatch, getState, { socket }) => {
      socket?.on(eventName, (payload) => {
        const { result, data } = payload || {};

        // Получаем значение, которое нужно передать в экшен:
        const valueToDispatch = raw ? payload : data;

        // Если raw === true или result === 'ok' — диспатчим успех
        if (raw || result === 'ok') {
          const action =
            typeof actionOrType === 'string'
              ? { type: actionOrType, payload: valueToDispatch }
              : actionOrType(valueToDispatch);

          dispatch(action);
          return;
        }

        // Ошибка — диспатчим fallback-обработчик или логируем
        if (onError) {
          dispatch(onError(data || payload));
        } else {
          console.warn(`[${eventName}] Ошибка в ответе сокета:`, payload);
        }
      });
      //возвращение функции для отписки от события при размонтировании компонента
      return () => {
        socket.off(eventName);
      };
    };
};
